import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

import DatePicker from '../../../components/elements/DatePicker'
import GridCards from '../../../components/grid/GridCards'

import getFilteredEventsForDateRange from '../../../utilities/events/getFilteredEventsForDateRange'

import '../../../styles/scss/components/grid/grid.scss'

const labelDateFormat = process.env.REACT_APP_FORMAT_GRID_CARD_HEADING_DATE

const WeeklyGridContainer = () => {
  const activeDate = useSelector(state => state.filtersData.date)
  const activeCategory = useSelector(state => state.filtersData.category)
  const eventsData = useSelector(state => state.eventsData)

  const activeStartDate = moment(activeDate)
  const activeEndDate = activeStartDate.clone().add(6, 'days')
  const filteredEvents = getFilteredEventsForDateRange(eventsData, activeCategory, activeStartDate, activeEndDate)
  const gridLabel = `${activeStartDate.format(labelDateFormat)} - ${activeEndDate.format(labelDateFormat)}`

  return (
    <div className="flow-events__grid">
      <div className="u-container">
        <div className="flow-events__grid-sidebar">
          <DatePicker isWeeklyView />
        </div>
        <div className="flow-events__grid-content">
          <GridCards
            events={filteredEvents}
            isCategoryFilterActive={activeCategory !== ''}
            label={gridLabel}
          />
        </div>
      </div>
    </div>
  )
}

export default WeeklyGridContainer
